Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "DropdownBase1394973313",
  {"root":"DropdownBase1394973313--root","arrowIcon":"DropdownBase1394973313--arrowIcon","optionIcon":"DropdownBase1394973313--optionIcon","childrenWrapper":"DropdownBase1394973313--childrenWrapper","BorderHoverColor":"color-5","borderHoverColor":"\"color(color-5)\"","DefaultBorderWidth":"1px"},
  "",
  8,
  "DropdownBase1394973313"
);

